const REPAYMENT_STATUS = {
  pending: { type: 'warning', text: 'Dossier complet - En traitement' },
  done: { type: 'success', text: 'Remboursement effectué' }
};

const getRepaymentStatus = (dateMiseEnBanque) =>
  dateMiseEnBanque ? REPAYMENT_STATUS.done : REPAYMENT_STATUS.pending;

export default getRepaymentStatus;
